var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasData
    ? _c("div", { staticClass: "reporting-section" }, [
        _c("div", { staticClass: "section-header" }, [
          _c("i", { staticClass: "material-icons section-icon" }, [
            _vm._v("insert_chart"),
          ]),
          _c("h2", [
            _vm._v(
              _vm._s(_vm.$t("dash.reporting.section.posts.title")) +
                " — Types & Jours"
            ),
          ]),
        ]),
        _c("div", { staticClass: "charts-grid" }, [
          _vm.typeChart
            ? _c("div", { staticClass: "chart-block" }, [
                _c("div", { staticClass: "chart-label" }, [
                  _vm._v(_vm._s(_vm.$t("dash.label.linkedin.typePosts_graph"))),
                ]),
                _c(
                  "div",
                  { staticClass: "chart-wrap" },
                  [
                    _c("Graph", {
                      attrs: {
                        id: `post-type-count-${_vm.pageId}`,
                        data: _vm.typeChart.data,
                        labels: _vm.typeChart.labels,
                        height: "200px",
                        width: "100%",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.typeEngChart
            ? _c("div", { staticClass: "chart-block" }, [
                _c("div", { staticClass: "chart-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("dash.label.linkedin.typePosts_engagement_graph")
                    )
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "chart-wrap" },
                  [
                    _c("Graph", {
                      attrs: {
                        id: `post-type-eng-${_vm.pageId}`,
                        data: _vm.typeEngChart.data,
                        labels: _vm.typeEngChart.labels,
                        height: "200px",
                        width: "100%",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.dayChart
            ? _c("div", { staticClass: "chart-block" }, [
                _c("div", { staticClass: "chart-label" }, [
                  _vm._v(_vm._s(_vm.$t("dash.label.linkedin.dayPosts_graph"))),
                ]),
                _c(
                  "div",
                  { staticClass: "chart-wrap" },
                  [
                    _c("Graph", {
                      attrs: {
                        id: `post-day-count-${_vm.pageId}`,
                        data: _vm.dayChart.data,
                        labels: _vm.dayChart.labels,
                        height: "200px",
                        width: "100%",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.dayEngChart
            ? _c("div", { staticClass: "chart-block" }, [
                _c("div", { staticClass: "chart-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("dash.label.linkedin.dayPosts_engagement_graph")
                    )
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "chart-wrap" },
                  [
                    _c("Graph", {
                      attrs: {
                        id: `post-day-eng-${_vm.pageId}`,
                        data: _vm.dayEngChart.data,
                        labels: _vm.dayEngChart.labels,
                        height: "200px",
                        width: "100%",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }